class CommonTNTControlBase {
    constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        this.Auth = Auth
        this.$state = $state
        this.User = User
        this.Service = Service
        this.Modal = Modal
        this.$translate = $translate
        this.$stateParams = $stateParams
    }

}

export default CommonTNTControlBase;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/util/CommonTNTControlBase.js